import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'teiasoft-link',
  templateUrl: './teiasoft-link.component.html',
  styleUrls: ['./teiasoft-link.component.scss']
})

export class TeiasoftLinkComponent implements OnInit, AfterViewInit{
  @Input() text:string = "";
  @Input() disabled: boolean = false;
  @Input() active: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  mlWidth:number = 0;

  constructor(){

  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
 
  }

  /***
   * EVENT EMITTER
   */
  onLinkClick(){
    this.onClick.emit();
  }
}
